import { render, staticRenderFns } from "./Correspondente.vue?vue&type=template&id=031f16a3&scoped=true"
import script from "./Correspondente.vue?vue&type=script&lang=js"
export * from "./Correspondente.vue?vue&type=script&lang=js"
import style0 from "./Correspondente.vue?vue&type=style&index=0&id=031f16a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031f16a3",
  null
  
)

export default component.exports